(() => {
  'use strict';

  if (window.WUBPredictiveSearchLoader?.version === 1) return;

  const script = document.currentScript;
  let runtimePromise = null;

  function sibling(filename) {
    if (!script?.src) return '';
    const url = new URL(script.src, window.location.href);
    url.pathname = url.pathname.replace(/[^/]+$/, filename);
    url.search = '';
    url.hash = '';
    return url.href;
  }

  const runtimeSrc = sibling('wub-predictive-search-runtime.js');

  function load() {
    if (customElements.get('search-form')) return Promise.resolve(true);
    if (!runtimeSrc) return Promise.resolve(false);
    if (runtimePromise) return runtimePromise;

    runtimePromise = new Promise((resolve) => {
      const existing = document.querySelector('script[data-wub-predictive-runtime]');
      if (existing) {
        if (customElements.get('search-form')) resolve(true);
        else existing.addEventListener('load', () => resolve(true), { once: true });
        return;
      }

      const node = document.createElement('script');
      node.src = runtimeSrc;
      node.defer = true;
      node.dataset.wubPredictiveRuntime = 'true';
      node.addEventListener('load', () => resolve(true), { once: true });
      node.addEventListener('error', () => {
        runtimePromise = null;
        resolve(false);
      }, { once: true });
      document.head.appendChild(node);
    });

    return runtimePromise;
  }

  function hasSearchIntent(target) {
    return Boolean(target?.closest?.('[data-wub-search-open], #Search-Drawer, search-form'));
  }

  document.addEventListener('pointerover', (event) => {
    if (hasSearchIntent(event.target)) load();
  }, { capture: true, passive: true });

  document.addEventListener('focusin', (event) => {
    if (hasSearchIntent(event.target)) load();
  }, true);

  document.addEventListener('click', (event) => {
    if (hasSearchIntent(event.target)) load();
  }, true);

  document.addEventListener('input', (event) => {
    const target = event.target;
    if (!target?.closest?.('search-form') || customElements.get('search-form')) return;
    load().then((ready) => {
      if (!ready || !target.isConnected) return;
      target.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }, true);

  window.WUBPredictiveSearchLoader = Object.freeze({ version: 1, load });
})();
